function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6617 10C17.4008 10 18.0114 9.39668 17.8883 8.66787C17.6159 7.05446 16.8527 5.55166 15.6868 4.3733C14.2049 2.87553 12.1919 2.02285 10.0851 2.00045C7.97818 1.97805 5.94752 2.78773 4.43408 4.25365C2.92064 5.71957 2.04661 7.72337 2.00181 9.82989C1.95701 11.9364 2.74505 13.9756 4.1948 15.5045C5.64454 17.0335 7.63894 17.9287 9.74486 17.9959C11.8508 18.0631 13.8982 17.2968 15.4425 15.8634C16.6574 14.7357 17.4838 13.2667 17.8246 11.6663C17.9785 10.9434 17.3941 10.3147 16.6557 10.2832V10.2832C15.9172 10.2518 15.3092 10.8349 15.0951 11.5423C14.8239 12.438 14.319 13.2543 13.6215 13.9016C12.594 14.8555 11.2316 15.3654 9.83023 15.3207C8.4289 15.276 7.10178 14.6802 6.13708 13.6628C5.17239 12.6454 4.64801 11.2885 4.67782 9.88681C4.70763 8.48508 5.28923 7.15171 6.29631 6.17625C7.30339 5.20079 8.65463 4.66201 10.0566 4.67692C11.4586 4.69183 12.798 5.25921 13.7842 6.25586C14.4534 6.93227 14.9232 7.76933 15.156 8.6757C15.3399 9.39159 15.9226 10 16.6617 10V10Z",
  fill: "url(#paint0_angular)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_angular",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10 10) scale(8)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})));

var SvgSpinner = function SvgSpinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spinner.54535864.svg";
export { ForwardRef as ReactComponent };